import React, { useEffect, useState } from "react";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../../../firebase";
import { Button } from "../../../design/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../design/dialog";
import { Input } from "../../../design/input";
import {
  Field,
  Fieldset,
  FieldGroup,
  Label,
  ErrorMessage,
} from "../../../design/fieldset";
import { useIntake } from "../../../contexts/IntakeContext";
import { Intake } from "../../../models/Intake";
import { getSubdomainFromUrl } from "../../../utils/url";
import { Textarea } from "../../../design/textarea";

interface Props {
  intakeItem: Intake;
}

interface Errors {
  identifier?: string;
  email?: string;
  dob?: string;
}

const EditIntakeButton: React.FC<Props> = ({ intakeItem }) => {
  const { updateIntake } = useIntake();
  const [isOpen, setIsOpen] = useState(false);
  const [identifier, setIdentifier] = useState<string>("");
  const [intakeSummary, setIntakeSummary] = useState<string>("");
  const [importantDetails, setImportantDetails] = useState<string>("");
  const [errors, setErrors] = useState<Errors>({});
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {}, [intakeItem, isOpen]);

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    if (!identifier.trim()) {
      newErrors.identifier = "A identifier is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    setIsSaving(true);

    try {
      let data: {
        identifier: string;
        avatarUrl?: string;
        intakeSummary: string;
      } = {
        identifier,
        intakeSummary,
      };
      // await updateIntake(intakeItem._id, data);
      clearForm();
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Failed to update intake. Please try again later.");
    }

    setIsSaving(false);
  };

  const clearForm = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button type="button" onClick={() => setIsOpen(true)}>
        Edit
      </Button>
      <Dialog open={isOpen} onClose={setIsOpen}>
        <DialogTitle>Edit Intake</DialogTitle>
        <DialogBody>
          <Fieldset>
            <Field>
              <Label>Identifier</Label>
              <Input
                type="text"
                value={identifier}
                placeholder="Identifier"
                onChange={(e) => setIdentifier(e.target.value)}
              />
              {errors.identifier && (
                <ErrorMessage>{errors.identifier}</ErrorMessage>
              )}
            </Field>
            <Field>
              <Label>Intake Summary</Label>
              <Textarea
                rows={5}
                value={intakeSummary}
                placeholder="Intake Summary"
                onChange={(e) => setIntakeSummary(e.target.value)}
              />
            </Field>
            <Field>
              <Label>Important Details</Label>
              <Textarea
                rows={5}
                value={importantDetails}
                placeholder="Important Details"
                onChange={(e) => setImportantDetails(e.target.value)}
              />
            </Field>
          </Fieldset>
        </DialogBody>
        <DialogActions>
          <Button plain onClick={clearForm}>
            Cancel
          </Button>
          <Button disabled={isSaving} onClick={handleSubmit}>
            {isSaving ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditIntakeButton;
